<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>


<script>
import { mapMutations } from 'vuex'
import { getSelectNewsList } from './api/api'
import { filterImg } from './utils/filterImg'
export default {
  name: 'app',
  data() {
    return {
      companyDynamicImg: [],
      mediaReportImg: [],
      jumpUrl: '',
      isMobile: ''
    }
  },
  created() {},
  methods: {
    checkDeviceType() {
      const hash = window.location.hash
      this.jumpUrl = hash == '#/objection' || hash == '#/announcement'
      this.isMobile = window.matchMedia("(max-width: 768px)").matches; // 768px 是一个常见的平板设备宽度
    },
    ...mapMutations({
      setCompanyDynamic: 'DYNAMIC',
      setCompanyDynamicImg: 'DYNAMICIMG',
      setDynamicTotal: 'DTOTAL',
      setMediaReport: 'REPORT',
      setMediaReportImg: 'REPORTIMG',
      setReportTotal: 'RTOTAL',
      setSocialBenefit: 'BENEFIT',
    }),
    getSelectNewsList(type, index = 1) {
      getSelectNewsList({
        newsType: type == 'company' ? 1 : type == 'benefit' ? 4 : 2, //1.公司动态  2.媒体报道  3.行业资讯
        page: index,
        size: type == 'benefit' ? 20 : 6,
      }).then((res) => {
        if (res.code != 0) return
        switch (type) {
          case 'company':
            this.getCompanyDynamic(res)
            break
          case 'news':
            this.getMediaReport(res)
            break
          case 'benefit':
            this.getSocialBenefit(res)
            break
        }
      })
    },
    // 卡尔动态
    getCompanyDynamic(res) {
      this.companyDynamicImg = []
      let imgReg = /<img.*?(?:>|\/>)/gi
      for (let i = 0; i < res.data.list.length; i++) {
        let arr = res.data.list[i].newsListImg.match(imgReg) // arr 为包含所有img标签的数组
        if (arr) {
          let src = filterImg(arr[0])
          this.companyDynamicImg.push(src[0])
        } else {
          this.companyDynamicImg.push('')
        }
      }
      this.setCompanyDynamic(res.data.list)
      this.setCompanyDynamicImg(this.companyDynamicImg)
      this.setDynamicTotal(res.data.maxPage)
    },
    // 行业新闻
    getMediaReport(res) {
      this.mediaReportImg = []
      let imgReg = /<img.*?(?:>|\/>)/gi
      for (let i = 0; i < res.data.list.length; i++) {
        let arr = res.data.list[i].newsListImg.match(imgReg) // arr 为包含所有img标签的数组
        if (arr) {
          let src = filterImg(arr[0])
          this.mediaReportImg.push(src[0])
        } else {
          this.mediaReportImg.push('')
        }
      }
      this.setMediaReport(res.data.list)
      this.setMediaReportImg(this.mediaReportImg)
      this.setReportTotal(res.data.maxPage)
    },
    // 社会公益
    getSocialBenefit(res) {
      this.setSocialBenefit(res.data.list)
    },
  },
  mounted() {
    // 监听窗口大小变化
    window.addEventListener("resize", this.checkDeviceType());
    // console.log('数据', filterImg())
    console.log(this.isMobile ? '移动端' : 'PC端', this.isMobile)
    if (this.isMobile) {
      const hash = window.location.hash
      if (hash == '#/objection') {
        window.location.href = 'https://www.carcredit.com.cn/mobile/#/objection'
      } else if (hash == '#/announcement') {
        window.location.href = 'https://www.carcredit.com.cn/mobile/#/announcement'
      } else {
        window.location.href = 'https://www.carcredit.com.cn/mobile/#/'
      }
    } else {
      // this.$router.replace('/')
    }
    // this.getSelectNewsList('company')
    // this.getSelectNewsList('news')
    // this.getSelectNewsList('benefit')
  },
  destroyed() {
    window.removeEventListener('resize', this.checkDeviceType())
  },
}
</script>

<style lang="scss">
#app {
  font-family: 'createBlack';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #ffffff;
  position: relative;
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
}
body {
  width: 100%;
  height: 100%;
  position: absolute;
  margin: 0px;
  padding: 0px;
  min-width: 1200px;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  // min-width: 1200px;
}

textarea {
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, SimSun, sans-serif;
}

.el-submenu [class^='fa'] {
  vertical-align: baseline;
  margin-right: 10px;
}

.el-menu-item [class^='fa'] {
  vertical-align: baseline;
  margin-right: 10px;
}

.toolbar {
  background: #fff;
  padding: 10px;
  .el-form-item {
    margin-bottom: 10px;
  }
}

//去除disabled置灰
.anti-disabled-gray {
  // 去除checkbox的置灰样式
  .el-checkbox {
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
      background-color: #20a0ff;
      border-color: #0190fe;
    }
    .el-checkbox__input.is-disabled .el-checkbox__inner {
      background-color: #ffffff;
      border-color: #bfcbd9;
    }
  }
  // 去除select的置灰样式
  .el-select {
    .el-input.is-disabled .el-input__inner {
      color: #1f2d3d;
      background-color: #ffffff;
      border-color: #bfcbd9;
    }
  }
}
//去除单选按钮的置灰样式
.el-radio-group {
  .el-radio-button.is-disabled.is-active .el-radio-button__inner {
    color: #fff;
    background-color: #20a0ff;
    border-color: #bfcbd9;
  }
  .el-radio-button.is-disabled .el-radio-button__inner {
    color: #1f2d3d;
    background-color: white;
    border-color: #bfcbd9;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue